module.exports = __webpack_public_path__ + "static/img/6834_phase_function_Paper_PointsHejduk_Prediction.ece1a0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6834_phase_function_Paper_PointsHejduk_Prediction.png
// module id = G8oP
// module chunks = 0